<template>
  <BDropdown
    :text="currentSelectedLang"
    toggle-class="dropdown-bordered icon-arrow-down5"
    variant="none"
    menu-class="navigation-dropdown dropdown-row"
    :popperOpts="popperOpts"
    :style="{ display: inline ? 'block' : '' }"
  >
    <BDropdownItem v-for="lang in unselectedLangs" :key="lang" @click.prevent="setLocale(lang)">
      {{ $t(`langs.${lang}`) }}
    </BDropdownItem>
  </BDropdown>
</template>

<script setup>
import {
  ref, computed, watch, onMounted,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { ALL_LANGS, i18n } from '../config';
import { BDropdown, BDropdownItem } from 'bootstrap-vue-next';

const inline = ref(false);
const t = useI18n();

const langs = ALL_LANGS;
const route = useRoute();
const router = useRouter();
const localeRef = ref(t.locale.value);

const popperOpts = {
  modifiers: {
    applyStyle: {
      enabled: true,
    },
  },
};

onMounted(async () => {
  await router.isReady();
  localeRef.value = route.params.lang || t.locale.value;
});

const currentSelectedLang = computed(() => i18n.global.t(`langs.${localeRef.value}`));

const unselectedLangs = computed(() => langs.filter((lang) => lang !== localeRef.value));

const setLocale = (lang) => {
  const currentName = route.name;
  const currentLang = localeRef.value;

  if (currentName) {
    const newRouteName = currentName.replace(`-${currentLang}`, `-${lang}`);
    localeRef.value = lang;
    t.locale.value = lang;
    router.push({ name: newRouteName, params: { lang } });
  } else {
    router.push({ name: `home-${currentLang}`, params: { lang } });
  }
};

watch(() => inline.value, (value) => {
  popperOpts.modifiers.applyStyle.enabled = !value;
});

watch(() => t.locale.value, (newLocale) => {
  localeRef.value = newLocale;
});
</script>
